import React, { FC } from "react"
import CustomPrismicTitle from "../atoms/CustomPrismicTitle"
import { IQuoteSlice } from "../../prismic-types/slices/quote-slice"
import styled from "styled-components"

// styles
import colors from "../../styles/colors"
import mq from "../../styles/breakpoints"
import { fontWeights } from "../../styles/textStyles"
import { fonts } from "../../styles/fonts"

const QuoteSlice: FC<IQuoteSlice> = ({
  primary,
  color = colors.purpleLight,
}) => {
  return (
    <Container>
      <Label>{primary.subtitle}</Label>
      <CustomPrismicTitle data={primary.title} color={color} />
    </Container>
  )
}

export default QuoteSlice

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0px 24px 0px 24px;

  ${mq.from.M`
  padding: 0px 128px 0px 128px;
`}
`

const Label = styled.h4`
  font-family: ${fonts.primary};
  font-size: 18px;
  line-height: 18px;
  font-weight: ${fontWeights.regular};
  letter-spacing: 2px;
  color: ${colors.main["100"]};
  margin-bottom: 0px;
  text-transform: uppercase;
`
